import { useCurrentUserQuery } from 'src/context/api/auth';

export const getTabs = (role: string | undefined) => {
    const tabs: any = {
        "/": [
            { title: "Workspaces list" }
        ],
        "/404": [
            { title: "404 Not Found" }
        ],
        "/workspaces": [
            { title: "Workspaces list" }
        ],
        "/admin/cockpit": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/admin/users": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/admin/users/add": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/admin/sso": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/account": [
            { title: "Profile" },
        ],
        "/brand-overview": [
            { title: "Brand Overview" },
        ],
        "/competitors-monitoring": [
            { title: "Competitors Monitoring" },
        ],
        "/competitor-focus": [
            { title: "Competitors Focus" },
        ],
        "/text-ads": [
            { title: "Text Ads" },
        ],
        "/product-listing-ads": [
            { title: "Product Listing Ads" },
        ],
        "/brand-wayback": [
            { title: "Brand Wayback" },
        ],
        "/brand/campaign-leaks": [
            { title: "Campaign Leaks" },
        ],
        "/brand/search-performance/overview": [
            { title: "Search Performance", label: "Overview", path: "/brand/search-performance/overview" },
            { title: "Search Performance", label: "Traffic", path: "/brand/search-performance/funnel" },
            { title: "Search Performance", label: "Cluster Manager", path: "/brand/search-performance/cluster-manager" }
        ],
        "/optimization/conversions-analysis": [
            { title: "Search Performance", label: "Overview", path: "/brand/search-performance/overview" },
            { title: "Search Performance", label: "Traffic", path: "/brand/search-performance/funnel" },
            { title: "Search Performance", label: "Cluster Manager", path: "/brand/search-performance/cluster-manager" }
        ],
        "/brand/search-performance/funnel": [
            { title: "Search Performance", label: "Overview", path: "/brand/search-performance/overview" },
            { title: "Search Performance", label: "Traffic", path: "/brand/search-performance/funnel" },
            { title: "Search Performance", label: "Cluster Manager", path: "/brand/search-performance/cluster-manager" }
        ],
        "/brand/search-performance/explore": [
            { title: "Search Performance", label: "Overview", path: "/brand/search-performance/overview" },
            { title: "Search Performance", label: "Traffic", path: "/brand/search-performance/funnel" },
            { title: "Search Performance", label: "Cluster Manager", path: "/brand/search-performance/cluster-manager" }
        ],
        "/brand/search-performance/cluster-manager": [
            { title: "Search Performance", label: "Overview", path: "/brand/search-performance/overview" },
            { title: "Search Performance", label: "Traffic", path: "/brand/search-performance/funnel" },
            { title: "Search Performance", label: "Cluster Manager", path: "/brand/search-performance/cluster-manager" }
        ],

        "/brand/brand-shield/keywords/exact": [
            { title: "Brand Shield", label: "Keyword (Exact)", path: "/brand/brand-shield/keywords/exact" },
            { title: "Brand Shield", label: "Keyword (Other)", path: "/brand/brand-shield/keywords/other" },
            { title: "Brand Shield", label: "Campaigns", path: "/brand/brand-shield/campaigns" },
            { title: "Brand Shield", label: "Scraping", path: "/brand/brand-shield/scraping" },
            { title: "Brand Shield", label: "Brand Infringement", path: "/brand/brand-shield/brand-infringement", badge: "brandInfringement" },
        ],

        "/brand/brand-shield/keywords/other": [
            { title: "Brand Shield", label: "Keyword (Exact)", path: "/brand/brand-shield/keywords/exact" },
            { title: "Brand Shield", label: "Keyword (Other)", path: "/brand/brand-shield/keywords/other" },
            { title: "Brand Shield", label: "Campaigns", path: "/brand/brand-shield/campaigns" },
            { title: "Brand Shield", label: "Scraping", path: "/brand/brand-shield/scraping" },
            { title: "Brand Shield", label: "Brand Infringement", path: "/brand/brand-shield/brand-infringement", badge: "brandInfringement" },
        ],

        "/brand/brand-shield/campaigns": [
            { title: "Brand Shield", label: "Keyword (Exact)", path: "/brand/brand-shield/keywords/exact" },
            { title: "Brand Shield", label: "Keyword (Other)", path: "/brand/brand-shield/keywords/other" },
            { title: "Brand Shield", label: "Campaigns", path: "/brand/brand-shield/campaigns" },
            { title: "Brand Shield", label: "Scraping", path: "/brand/brand-shield/scraping" },
            { title: "Brand Shield", label: "Brand Infringement", path: "/brand/brand-shield/brand-infringement", badge: "brandInfringement" },
        ],

        "/brand/brand-shield/scraping": [
            { title: "Brand Shield", label: "Keyword (Exact)", path: "/brand/brand-shield/keywords/exact" },
            { title: "Brand Shield", label: "Keyword (Other)", path: "/brand/brand-shield/keywords/other" },
            { title: "Brand Shield", label: "Campaigns", path: "/brand/brand-shield/campaigns" },
            { title: "Brand Shield", label: "Scraping", path: "/brand/brand-shield/scraping" },
            { title: "Brand Shield", label: "Brand Infringement", path: "/brand/brand-shield/brand-infringement", badge: "brandInfringement" },
        ],

        "/brand/brand-shield/brand-infringement": [
            { title: "Brand Shield", label: "Keyword (Exact)", path: "/brand/brand-shield/keywords/exact" },
            { title: "Brand Shield", label: "Keyword (Other)", path: "/brand/brand-shield/keywords/other" },
            { title: "Brand Shield", label: "Campaigns", path: "/brand/brand-shield/campaigns" },
            { title: "Brand Shield", label: "Scraping", path: "/brand/brand-shield/scraping" },
            { title: "Brand Shield", label: "Brand Infringement", path: "/brand/brand-shield/brand-infringement", badge: "brandInfringement" },
        ],

        "/brand/visibility/overview": [
            { title: "Visibility", label: "Overview", path: "/brand/visibility/overview" },
            { title: "Visibility", label: "Competitors", path: "/brand/visibility/competitors" },
            { title: "Visibility", label: "Search terms", path: "/brand/visibility/search-terms" },
            { title: "Visibility", label: "Ad & SERP library", path: "/brand/visibility/ads" },
        ],
        "/brand/visibility/competitors": [
            { title: "Visibility", label: "Overview", path: "/brand/visibility/overview" },
            { title: "Visibility", label: "Competitors", path: "/brand/visibility/competitors" },
            { title: "Visibility", label: "Search terms", path: "/brand/visibility/search-terms" },
            { title: "Visibility", label: "Ad & SERP library", path: "/brand/visibility/ads" },
        ],
        "/brand/visibility/search-terms": [
            { title: "Visibility", label: "Overview", path: "/brand/visibility/overview" },
            { title: "Visibility", label: "Competitors", path: "/brand/visibility/competitors" },
            { title: "Visibility", label: "Search terms", path: "/brand/visibility/search-terms" },
            { title: "Visibility", label: "Ad & SERP library", path: "/brand/visibility/ads" },
        ],
        "/brand/visibility/ads": [
            { title: "Visibility", label: "Overview", path: "/brand/visibility/overview" },
            { title: "Visibility", label: "Competitors", path: "/brand/visibility/competitors" },
            { title: "Visibility", label: "Search terms", path: "/brand/visibility/search-terms" },
            { title: "Visibility", label: "Ad & SERP library", path: "/brand/visibility/ads" },
        ],
        "regexp:^/workspaces/(?<id>[0-9]+)": [
            { title: "Administration" },
        ],
        "/non-brand/search-performance": [
            { title: "Search Performance" },
        ],
        "/competitors/leaderboard/market-leaders": [
            { title: "Leaderboard", label: "Market leaders", path: "/competitors/leaderboard/market-leaders" },
            { title: "Leaderboard", label: "Tracked competitors", path: "/competitors/leaderboard/tracked-competitors" },
            { title: "Leaderboard", label: "Competitors selection", path: "/competitors/leaderboard/competitors-selection" },
        ],
        "/competitors/leaderboard/competitors-selection": [
            { title: "Leaderboard", label: "Market leaders", path: "/competitors/leaderboard/market-leaders" },
            { title: "Leaderboard", label: "Tracked competitors", path: "/competitors/leaderboard/tracked-competitors" },
            { title: "Leaderboard", label: "Competitors selection", path: "/competitors/leaderboard/competitors-selection" },
        ],
        "/competitors/leaderboard/tracked-competitors": [
            { title: "Leaderboard", label: "Market leaders", path: "/competitors/leaderboard/market-leaders" },
            { title: "Leaderboard", label: "Tracked competitors", path: "/competitors/leaderboard/tracked-competitors" },
            { title: "Leaderboard", label: "Competitors selection", path: "/competitors/leaderboard/competitors-selection" },
        ],
        "/non-brand/visibility": [
            { title: "Visibility" },
        ],
        "/competitors/conquest-mode": [
            { title: "Conquest Mode" },
        ]
    };

    if (role?.toLowerCase() !== "admin") {
        Object.keys(tabs).forEach((key) => {
            tabs[key] = tabs[key].filter((tab: any) => !tab.adminOnly);
        });
    }


    return tabs;
};
